import * as React from 'react';
import { Form, Text, Select, TextArea } from 'react-form';
import Select2 from 'react-select/lib/Creatable';
import { api } from '@src/services/api';
import { checkLevel } from "@src/services/user";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Box, Modal } from '@src/components';
import Loading from '@src/components/UI/Loading';

export interface LocalProps {
    id: any;
    get: string;
    mount: string;
    unmount: string;
    action: "mount" | "unmount";
    onSuccess?: Function;
    onCancel?: Function;
}
export interface LocalState {
    devid: any;
    items: any;
    error: any;
}

// style
const style = css`
    form, article {
        ${mixin.form}
    }
`;

// component
export class BatteryMount extends React.Component<LocalProps, LocalState> {
    state = {} as LocalState;

    async componentWillMount() {
        const { action, get } = this.props;
        if (action === "mount") {
            const res = await api({
                url: get,
                method: 'get'
            });
            this.setState({
                items: res.data.data
            })
        }
    }

    async save( devid ) {
        const { id, mount, onSuccess } = this.props;
        try {
            const res = await api({
                url: mount,
                method: 'put',
                params: {
                    battid: id,
                    devid
                }
            });
            if (onSuccess) {
                onSuccess(res);
            }
        } catch(e) {
            this.setState({
                error: e.response.data
            })
        }
    }

    async unmount( ) {
        const { id, unmount, onSuccess } = this.props;
        try {
            const res = await api({
                url: unmount,
                method: 'put',
                params: {
                    battid: id
                }
            });
            if (onSuccess) {
                onSuccess(res);
            }
        } catch(e) {
            this.setState({
                error: e.response.data
            })
        }
    }

    outputError() {
        const { error } = this.state;
        if (!error.errors) { return null; }
        const errors = Object.keys(error.errors).reduce( (acc, e) => {
            return [...acc, ...error.errors[e] ];
        }, [])
        return (
            <div className="errors">
                <div><strong>{error.message}</strong></div>
                <ul>
                    {errors.map( (v,k) => (
                        <li key={k}>{v}</li>
                    ) )}
                </ul>
            </div>
        )
    }
    
	// render
	render() {
        const { id, action, onCancel } = this.props;
        const { devid, items, error } = this.state;
        return (
            <Modal
                title={_(`${action}_battery_title`, 'SettingsBattery') }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
            {action === "mount" &&
                <>
                {!items &&
                <Loading />
                }
                {items &&
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.save(v.devid)}
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                            onChange={() => setTimeout(() => { this.setState({ devid: formApi.getFormState().values.devid }); }) }
                        >
                            <div className="fields">
                                <article className="full">
                                    <label htmlFor="devid">{_('field_devid', 'SettingsBattery')}</label>
                                    <Select field={"devid"} id="devid" options={items.map( v => ({ value: v.id, label: `${v.serialno} ${v.description || ''}` }))} className="form-control" />
                                </article>
                            </div>
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                    {_(`btn_cancel`, 'Settings')}
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={!devid}>
                                    {_(`mount_battery_btn`, 'SettingsBattery')}
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
                }
                </>
            }
            {action === "unmount" &&
                <>
                <div className={style}>
                    <article>
                        <footer>
                            <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                {_(`btn_cancel`, 'Settings')}
                            </button>
                            <button type="submit" className="btn btn-primary" onClick={() => { this.unmount() } }>
                                {_(`unmount_battery_btn`, 'SettingsBattery')}
                            </button>
                        </footer>
                    </article>
                </div>
                </>
            }
            </Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/Actions/BatteryMount.tsx